import { Component } from '@angular/core';

@Component({
  selector: 'app-userprofile',
  standalone: false,
  styleUrl: './userprofile.css',
  templateUrl: './userprofile.html',
})
export class Userprofile {}
